import React from 'react';
import { Image, Shimmer } from 'react-shimmer'

export default class SearchDoctorListItem extends React.Component {
  render() {
    return (
      <a className="search-results__item" href={this.props.doctor.url}>
        <Image
          src={this.props.doctor.avatar_url}
          fallback={<Shimmer width={40} height={40} />}
          errorFallback={() => (
            <Shimmer width={40} height={40} />
          )}
          NativeImgProps={{ className: 'search-results__avatar', alt: this.props.doctor.name }}
        />
        <div className="search-results__item-content">
          <div className="search-results__item-title">{this.props.doctor.name}</div>
          <div className="search-results__item-subtitle">{this.props.doctor.speciality}</div>
        </div>
      </a>
    );
  }
}
